// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.routing-body {
    height: 100%;
    display: flex;
    flex-direction: column;
}

div.routing-buttonbar {
    flex: 0 0 auto;
}

div.routing-frame {
    border: 1px solid var(--border-color);
    padding: 0.25em;
    flex: 1 1 auto;
    min-height: 0;
    display: flex;
    flex-direction: column;
}

div.routing-buttons {
    display: flex;
    align-items: center;
    position: relative;
    flex: 0 0 auto;
}

div.routing-buttons > div.ButtonBar {
    flex: 1 1 auto;
}

div.routing-buttons div.routing-settings-menu {
    position: absolute;
    left: 0;
    right: 0;
    top: calc(100% - 0.25em - 1px);
    max-height: 200px;
    overflow-y: auto;
    border: 1px solid var(--border-color);
    background-color: var(--container-bg-color);
    box-shadow: 0px 0px 5px rgba(136, 136, 136, 1);
    z-index: 1;
    padding: 0.25em;
}

div.routing-tab-widget {
    flex: 1 1 auto;
    min-height: 0;
    display: flex;
    flex-direction: column;
}

div.routing-input {
    flex: 0 0 auto;
}

table.routing-settings-menu-entries td {
    white-space: nowrap;
}

table.routing-settings-menu-entries td:last-child > * {
    width: 100%;
}

div.routing-points {
    display: flex;
    align-items: center;
}

div.routing-points > div:first-child {
    flex: 1 1 auto;
}

div.routing-points > div:last-child {
    flex: 0 0 auto;
    margin-left: 0.25em;
}

div.routing-points-commands {
    margin: 0.25em 0;
    display: flex;
    align-items: center;
}

div.routing-points-commands > span.routing-points-commands-spacer {
    flex: 1 1 auto;
}

div.routing-points-commands > div.VectorLayerPicker {
    flex: 1 1 auto;
}

div.routing-search-field {
    display: flex;
    margin-bottom: 0.25em;
}

div.routing-search-field input.search-widget-input[type=text] {
    border: none;
    outline: none;
    height: calc(2em - 2px);
}

div.routing-search-field button.button {
    border-right: none;
    width: 2em;
}

button.routing-compute-button {
    width: 100%;
}

div.routing-status-failure {
    text-align: center;
    color: red;
    font-style: italic;
    padding: 0.25em;
}

div.routing-busy {
    display: flex;
    align-items: center;
    flex: 0 0 auto;
}

div.routing-busy > div.spinner {
    width: 2em;
    height: 2em;
    margin-right: 0.25em;
}

div.routing-result {
    flex: 1 1 auto;
    min-height: 0;
    display: flex;
    flex-direction: column;
}

div.routing-result-summary {
    margin-top: 0.5em;
    border-top: 1px solid var(--border-color);
    padding: 0.25em;
    display: flex;
    align-items: center;
    flex: 0 0 auto;
}

div.routing-result-summary > span.icon {
    margin-right: 0.5em;
}

div.routing-result-summary > span.routing-result-spacer {
    flex: 1 1 auto;
}

div.routing-result-instructions {
    background-color: var(--input-bg-color);
    border-top: 1px solid var(--border-color);
    padding: 0.25em;
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: scroll;
    font-size: 90%;
}

div.routing-result-instruction {
    padding: 0.5em;
}

div.routing-result-instruction:hover {
    background-color: var(--list-item-bg-color-hover);
    color: var(--list-item-text-color-hover);
}

div.routing-result-instruction:not(:last-child) {
    border-bottom: 1px solid var(--border-color);
}

div.routing-result-instruction span.icon {
    margin-right: 0.5em;
}

div.routing-result-instruction-summary {
    padding: 0.25em;
    display: flex;
    align-items: center;
}

div.routing-result-instruction-summary > span.icon {
    margin-right: 0.5em;
}

div.routing-result-instruction-summary > span.routing-result-spacer {
    flex: 1 1 auto;
}

table.routing-iso-settings {
    width: 100%;
    white-space: nowrap;
}

table.routing-iso-settings td > input,
table.routing-iso-settings td > select {
    width: 100%;
}

input.routing-input-invalid {
    background-color: #FFAAAA!important;
}

div.routing-popup-button > button {
    width: 100%;
}

label.routing-import-button {
    position: relative;
    display: inline-block;
    cursor: pointer;
    color: var(--text-color-link);
}

label.routing-import-button:hover {
    text-decoration: underline;
}

label.routing-import-button > input {
    cursor: pointer;
    outline: none;
    position: absolute;
    top: 0;
    left: 0;
    width: 0;
    height: 0;
    overflow: hidden;
    opacity: 0;
}

div.routing-time-settings {
    padding: 0.5em 0;
    display: flex;
    align-items: center;
}

div.routing-time-settings > select {
    flex: 0 0 auto;
}

div.routing-time-settings > div {
    flex: 1 1 auto;
}
`, "",{"version":3,"sources":["webpack://./../qwc2/plugins/style/Routing.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qCAAqC;IACrC,eAAe;IACf,cAAc;IACd,aAAa;IACb,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,8BAA8B;IAC9B,iBAAiB;IACjB,gBAAgB;IAChB,qCAAqC;IACrC,2CAA2C;IAC3C,8CAA8C;IAC9C,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,yCAAyC;IACzC,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,uCAAuC;IACvC,yCAAyC;IACzC,eAAe;IACf,cAAc;IACd,aAAa;IACb,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iDAAiD;IACjD,wCAAwC;AAC5C;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;;IAEI,WAAW;AACf;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,aAAa;IACb,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB","sourcesContent":["div.routing-body {\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n}\n\ndiv.routing-buttonbar {\n    flex: 0 0 auto;\n}\n\ndiv.routing-frame {\n    border: 1px solid var(--border-color);\n    padding: 0.25em;\n    flex: 1 1 auto;\n    min-height: 0;\n    display: flex;\n    flex-direction: column;\n}\n\ndiv.routing-buttons {\n    display: flex;\n    align-items: center;\n    position: relative;\n    flex: 0 0 auto;\n}\n\ndiv.routing-buttons > div.ButtonBar {\n    flex: 1 1 auto;\n}\n\ndiv.routing-buttons div.routing-settings-menu {\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: calc(100% - 0.25em - 1px);\n    max-height: 200px;\n    overflow-y: auto;\n    border: 1px solid var(--border-color);\n    background-color: var(--container-bg-color);\n    box-shadow: 0px 0px 5px rgba(136, 136, 136, 1);\n    z-index: 1;\n    padding: 0.25em;\n}\n\ndiv.routing-tab-widget {\n    flex: 1 1 auto;\n    min-height: 0;\n    display: flex;\n    flex-direction: column;\n}\n\ndiv.routing-input {\n    flex: 0 0 auto;\n}\n\ntable.routing-settings-menu-entries td {\n    white-space: nowrap;\n}\n\ntable.routing-settings-menu-entries td:last-child > * {\n    width: 100%;\n}\n\ndiv.routing-points {\n    display: flex;\n    align-items: center;\n}\n\ndiv.routing-points > div:first-child {\n    flex: 1 1 auto;\n}\n\ndiv.routing-points > div:last-child {\n    flex: 0 0 auto;\n    margin-left: 0.25em;\n}\n\ndiv.routing-points-commands {\n    margin: 0.25em 0;\n    display: flex;\n    align-items: center;\n}\n\ndiv.routing-points-commands > span.routing-points-commands-spacer {\n    flex: 1 1 auto;\n}\n\ndiv.routing-points-commands > div.VectorLayerPicker {\n    flex: 1 1 auto;\n}\n\ndiv.routing-search-field {\n    display: flex;\n    margin-bottom: 0.25em;\n}\n\ndiv.routing-search-field input.search-widget-input[type=text] {\n    border: none;\n    outline: none;\n    height: calc(2em - 2px);\n}\n\ndiv.routing-search-field button.button {\n    border-right: none;\n    width: 2em;\n}\n\nbutton.routing-compute-button {\n    width: 100%;\n}\n\ndiv.routing-status-failure {\n    text-align: center;\n    color: red;\n    font-style: italic;\n    padding: 0.25em;\n}\n\ndiv.routing-busy {\n    display: flex;\n    align-items: center;\n    flex: 0 0 auto;\n}\n\ndiv.routing-busy > div.spinner {\n    width: 2em;\n    height: 2em;\n    margin-right: 0.25em;\n}\n\ndiv.routing-result {\n    flex: 1 1 auto;\n    min-height: 0;\n    display: flex;\n    flex-direction: column;\n}\n\ndiv.routing-result-summary {\n    margin-top: 0.5em;\n    border-top: 1px solid var(--border-color);\n    padding: 0.25em;\n    display: flex;\n    align-items: center;\n    flex: 0 0 auto;\n}\n\ndiv.routing-result-summary > span.icon {\n    margin-right: 0.5em;\n}\n\ndiv.routing-result-summary > span.routing-result-spacer {\n    flex: 1 1 auto;\n}\n\ndiv.routing-result-instructions {\n    background-color: var(--input-bg-color);\n    border-top: 1px solid var(--border-color);\n    padding: 0.25em;\n    flex: 1 1 auto;\n    min-height: 0;\n    overflow-y: scroll;\n    font-size: 90%;\n}\n\ndiv.routing-result-instruction {\n    padding: 0.5em;\n}\n\ndiv.routing-result-instruction:hover {\n    background-color: var(--list-item-bg-color-hover);\n    color: var(--list-item-text-color-hover);\n}\n\ndiv.routing-result-instruction:not(:last-child) {\n    border-bottom: 1px solid var(--border-color);\n}\n\ndiv.routing-result-instruction span.icon {\n    margin-right: 0.5em;\n}\n\ndiv.routing-result-instruction-summary {\n    padding: 0.25em;\n    display: flex;\n    align-items: center;\n}\n\ndiv.routing-result-instruction-summary > span.icon {\n    margin-right: 0.5em;\n}\n\ndiv.routing-result-instruction-summary > span.routing-result-spacer {\n    flex: 1 1 auto;\n}\n\ntable.routing-iso-settings {\n    width: 100%;\n    white-space: nowrap;\n}\n\ntable.routing-iso-settings td > input,\ntable.routing-iso-settings td > select {\n    width: 100%;\n}\n\ninput.routing-input-invalid {\n    background-color: #FFAAAA!important;\n}\n\ndiv.routing-popup-button > button {\n    width: 100%;\n}\n\nlabel.routing-import-button {\n    position: relative;\n    display: inline-block;\n    cursor: pointer;\n    color: var(--text-color-link);\n}\n\nlabel.routing-import-button:hover {\n    text-decoration: underline;\n}\n\nlabel.routing-import-button > input {\n    cursor: pointer;\n    outline: none;\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 0;\n    height: 0;\n    overflow: hidden;\n    opacity: 0;\n}\n\ndiv.routing-time-settings {\n    padding: 0.5em 0;\n    display: flex;\n    align-items: center;\n}\n\ndiv.routing-time-settings > select {\n    flex: 0 0 auto;\n}\n\ndiv.routing-time-settings > div {\n    flex: 1 1 auto;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
